var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import VueDialog from "../../interface/IVueDialog";
import Component from 'vue-class-component';
import UserService from '../../api/UserService';
import _ from 'lodash';
import { CachePocily } from '../../common/Cache';
import { ECache } from '../../enum/ECache';
import CACHE_KEY from "@/constant/cacheKey";
import RootType from '../../store/mutation-types';
import router from "@/router";
var TransferDialog = (function (_super) {
    __extends(TransferDialog, _super);
    function TransferDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            searchText: ""
        };
        _this.tableHeight = 300;
        _this.tableData = [];
        _this.cache = CachePocily.getInstance(ECache.LocCache);
        return _this;
    }
    TransferDialog.prototype.created = function () {
        this.service = UserService.getInstance();
    };
    TransferDialog.prototype.mounted = function () {
        var _this = this;
        this.getListData();
        setTimeout(function () {
            if (_this.$el && _this.$el.parentElement) {
                _this.tableHeight = _this.$el.parentElement.clientHeight - 130;
            }
        }, 300);
    };
    TransferDialog.prototype.getListData = function () {
        var _this = this;
        this.service.getAuthUserList({ keyword: this.formData.searchText || null }).then(function (res) {
            _this.tableData = res.data.data;
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    TransferDialog.prototype.setAdmin = function () {
        var _this = this;
        if (!this.formData.user) {
            this.$alert('请先选择用户！', '提示');
            return;
        }
        ;
        var user = _.find(this.tableData, function (item) { return item.account_id === _this.formData.user; });
        var title = '权限转移后，您的账号操作权限将清除并自动退出，如您仍需使用此账号，须管理员为您重新分配权限。请确认是否将管理员权限转移至' + user.account_name;
        this.$confirm(title, '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                _this.service.transferAuth({ account_id: user.account_id }).then(function (res) {
                    window._czc.push(["_trackEvent", '用户列表', '分配权限']);
                    _this.$closeDialog();
                    _this.$message.success(res.data.msg || '设置成功');
                    _this.cache.remove(CACHE_KEY.LOGIN);
                    _this.$store.commit(RootType.UPDATE_LOGINMODEL, null);
                    router.push({ path: '/' });
                }).catch(function (err) {
                    _this.$message.error(err.message);
                });
            }
        }).catch(function () {
        });
    };
    TransferDialog = __decorate([
        Component
    ], TransferDialog);
    return TransferDialog;
}(VueDialog));
export default TransferDialog;
